import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";

import useDidMountEffect from "../../utils/useDidMountEffect";

import HeadAdminModal from "./HeadAdminModal";

const HeadAdminsHeader = (props) => {
  const { headAdmins, setHeadAdmins } = props;
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const [showHeadAdminModal, setShowHeadAdminModal] = useState(false);

  const fetchHeadAdmins = (search) => {
    let url = "/head_admins";
    if (search) {
      url += "?search=" + search;
    }

    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setHeadAdmins(data.head_admins);
      });
  };

  useDidMountEffect(() => {
    fetchHeadAdmins(debouncedSearch);
  }, [debouncedSearch]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [search, 500]);

  return (
    <>
      {showHeadAdminModal && (
        <HeadAdminModal
          headAdmins={headAdmins}
          setHeadAdmins={setHeadAdmins}
          setShowHeadAdminModal={setShowHeadAdminModal}
        />
      )}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-4">
          <div className="relative">
            <input
              type="text"
              placeholder="Wyszukaj..."
              className="pl-10 pr-8 py-1.5 border border-gray-300 text-sm"
              onChange={(e) => setSearch(e.target.value)}
            />
            <svg
              className="w-4 h-4 absolute left-2.5 top-2.5 text-gray-400"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              viewBox="0 0 24 24"
            >
              <path d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 1010.5 18a7.5 7.5 0 006.15-3.35z" />
            </svg>
          </div>
        </div>

        <button
          className="flex items-center gap-2 bg-black text-white px-4 py-2 text-sm font-medium"
          onClick={() => setShowHeadAdminModal(!showHeadAdminModal)}
        >
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <path d="M12 4v16m8-8H4" />
          </svg>
          Dodaj Head Admina
        </button>
      </div>
    </>
  );
};

export default HeadAdminsHeader;

HeadAdminsHeader.propTypes = {
  headAdmins: PropTypes.array,
  setHeadAdmins: PropTypes.func,
};
